import React from "react";
import { useParams } from "react-router-dom";
import { TaskView } from "@/pages/Tasks/TaskView";

interface TaskPageProps {
    taskId?: string;
}

export const TaskPage: React.FC<TaskPageProps> = ({ taskId }) => {
    const { id: routeId } = useParams<{ id?: string }>();
    const id = taskId ?? routeId;
    if (!id) {
        return null;
    }

    return (
        <div className="w-full">
            <TaskView taskId={id} type="page" />
        </div>
    );
};
